import React, { useEffect, useRef, useState } from 'react';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { handlePostRequest } from '../../../service/PostTemplate';
import { endPoints } from '../../../Config';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleGetRequest } from '../../../service/GetTemplate';

const ViewDraftMerchant = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [form29File, setForm29File] = useState(null);
    const [ntnNumberFile, setNtnNumberFile] = useState(null);
    const [idCardFrontFile, setIdCardFrontFile] = useState(null);
    const [idCardBackFile, setIdCardBackFile] = useState(null);
    const [ownerPictureFile, setOwnerPictureFile] = useState(null);
    const [IsDraft, setIsDraft] = useState(false);
    const formData = new FormData();

    const location = useLocation();
    const { rowData } = location.state || {};

    const navigate = useNavigate();

    const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

    const DraftvalidationSchema = Yup.object().shape({
        CompanyName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Company Name must contain only alphanumeric values'),

        CompanyEmail: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required')
    });
    const validationSchema = Yup.object().shape({
        POCName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Owner Name must contain only alphanumeric values'),

        POCEmail: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required'),

        CompanyName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Company Name must contain only alphanumeric values'),

        CompanyEmail: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required'),

        OwnerPicture: Yup.string().required('This field is required'),
        Form29: Yup.string().required('This field is required'),
        NTNNumber: Yup.string().required('This field is required'),
        IDCardFront: Yup.string().required('This field is required'),
        IDCardBack: Yup.string().required('This field is required')
    });

    const stateSetters = {
        OwnerPicture: setOwnerPictureFile,
        Form29: setForm29File,
        NTNNumber: setNtnNumberFile,
        IDCardFront: setIdCardFrontFile,
        IDCardBack: setIdCardBackFile
    };

    const dispatch = useDispatch();

    const ownerPictureRef = useRef(null);
    const form29ImageRef = useRef(null);
    const ntnImageRef = useRef(null);
    const cnicFrontImageRef = useRef(null);
    const cnicBackImageRef = useRef(null);

    const handleOwnerIconClick = () => ownerPictureRef.current.click();
    const handleNtnIconClick = () => ntnImageRef.current.click();
    const handleIdCardFrontClick = () => cnicFrontImageRef.current.click();
    const handleIdCardBackClick = () => cnicBackImageRef.current.click();
    const handleForm29Click = () => form29ImageRef.current.click();

    const handleFileChange = (event, fieldKey) => {
        const selectedFile = event.target.files[0];

        formik.setFieldValue(fieldKey, selectedFile?.name);
        stateSetters[fieldKey](selectedFile);
    };

    const formik = useFormik({
        validationSchema: IsDraft ? DraftvalidationSchema : validationSchema,
        initialValues: {
            id: '',
            POCName: '',
            POCEmail: '',
            CompanyName: '',
            CompanyEmail: '',
            OwnerPicture: '',
            Form29: '',
            NTNNumber: '',
            IDCardFront: '',
            IDCardBack: '',
            CreatedBy: ''
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            formData.append('POCName', data?.POCName || '');
            formData.append('POCEmail', data?.POCEmail || '');
            formData.append('CompanyName', data?.CompanyName || '');
            formData.append('CompanyEmail', data?.CompanyEmail || '');
            formData.append('CreatedBy', user?.data?.userId || '');
            formData.append('IsDraft', IsDraft ? true : false);

            if (form29File) formData.append('Form29', form29File);
            if (ntnNumberFile) formData.append('NTNNumber', ntnNumberFile);
            if (idCardFrontFile) formData.append('IDCardFront', idCardFrontFile);
            if (idCardBackFile) formData.append('IDCardBack', idCardBackFile);
            if (ownerPictureFile) formData.append('OwnerPicture', ownerPictureFile);

            const response = await dispatch(handlePostRequest(formData, endPoints.addMerchant, true));
            if (response?.status === 200) {
                formik.resetForm();
                navigate('/draft-merchant-list');
            }
            setLoadingBtn(false);
        }
    });
    const downloadFile = (file, fileName) => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const getMerchantbyId = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getMerchantById(rowData.id), true);
        console.log('response', response);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('status', response?.data?.status);
            formik.setFieldValue('POCName', response?.data?.pocName);
            formik.setFieldValue('POCEmail', response?.data?.pocEmail);
            formik.setFieldValue('ownerPassword', response?.data?.ownerPassword);
            formik.setFieldValue('CompanyName', response?.data?.companyName);
            formik.setFieldValue('CompanyEmail', response?.data?.companyEmail);
            formik.setFieldValue('Form29', response?.data?.form29);
            formik.setFieldValue('NTNNumber', response?.data?.ntnNumber);
            formik.setFieldValue('IDCardFront', response?.data?.idCardFront);
            formik.setFieldValue('IDCardBack', response?.data?.idCardBack);
            formik.setFieldValue('OwnerPicture', response?.data?.ownerPicture);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        getMerchantbyId();
    }, [rowData]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="p-4">
                <div className="flex justify-content-between align-items-center mb-3">
                    <h3>Edit Draft Merchant</h3>
                </div>
                <div className="grid p-fluid">
                    <div className="col-12 md:col-12 border-bottom-1 mb-2 font-semibold">POC Info</div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCName">POC Name</label>
                            <InputText id="POCName" name="POCName" placeholder="Enter Owner Name" value={formik?.values?.POCName} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.POCName && formik.errors.POCName && <small className="p-error">{formik.errors.POCName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCEmail">POC Email</label>
                            <InputText id="POCEmail" name="POCEmail" placeholder="Enter Owner Email" value={formik?.values?.POCEmail} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.POCEmail && formik.errors.POCEmail && <small className="p-error">{formik.errors.POCEmail}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-12 border-bottom-1 mb-2 font-semibold">Company Info</div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyName">Company Name</label>
                            <InputText id="CompanyName" name="CompanyName" placeholder="Enter Company Name" value={formik?.values?.CompanyName} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.CompanyName && formik.errors.CompanyName && <small className="p-error">{formik.errors.CompanyName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyEmail">Company Email</label>
                            <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                            {formik.touched.CompanyEmail && formik.errors.CompanyEmail && <small className="p-error">{formik.errors.CompanyEmail}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4"></div>
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload Form 29</label>
                                <div className="file-input-container file-input-wrapper w-100" onClick={handleForm29Click}>
                                    <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={form29ImageRef} onChange={(e) => handleFileChange(e, 'Form29')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.Form29} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.Form29 && formik.errors.Form29 ? <small className="p-error">{formik.errors.Form29}</small> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button icon="pi pi-arrow-down" tooltip="Download File" rounded aria-label="Download" onClick={() => downloadFile(form29File, formik?.values?.Form29)} disabled={!form29File} />
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload NTN Number</label>
                                <div className="file-input-container file-input-wrapper w-100" onClick={handleNtnIconClick}>
                                    <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={ntnImageRef} onChange={(e) => handleFileChange(e, 'NTNNumber')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.NTNNumber} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.NTNNumber && formik.errors.NTNNumber ? <small className="p-error">{formik.errors.NTNNumber}</small> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button icon="pi pi-arrow-down" rounded aria-label="Download NTN" onClick={() => downloadFile(ntnNumberFile, formik?.values?.NTNNumber)} disabled={!ntnNumberFile} tooltip="Download File" />
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload CNIC Front</label>
                                <div className="file-input-container file-input-wrapper w-100" onClick={handleIdCardFrontClick}>
                                    <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={cnicFrontImageRef} onChange={(e) => handleFileChange(e, 'IDCardFront')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.IDCardFront} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.IDCardFront && formik.errors.IDCardFront ? <small className="p-error">{formik.errors.IDCardFront}</small> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button icon="pi pi-arrow-down" rounded aria-label="Download CNIC Front" onClick={() => downloadFile(idCardFrontFile, formik?.values?.IDCardFront)} disabled={!idCardFrontFile} tooltip="Download File" />
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload CNIC Back</label>
                                <div className="file-input-container file-input-wrapper w-100" onClick={handleIdCardBackClick}>
                                    <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={cnicBackImageRef} onChange={(e) => handleFileChange(e, 'IDCardBack')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.IDCardBack} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.IDCardBack && formik.errors.IDCardBack ? <small className="p-error">{formik.errors.IDCardBack}</small> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button icon="pi pi-arrow-down" rounded aria-label="Download CNIC Back" onClick={() => downloadFile(idCardBackFile, formik?.values?.IDCardBack)} disabled={!idCardBackFile} tooltip="Download File" />
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload Picture</label>
                                <div className="file-input-container file-input-wrapper w-100" onClick={handleOwnerIconClick}>
                                    <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} disabled />
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={ownerPictureRef} onChange={(e) => handleFileChange(e, 'OwnerPicture')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.OwnerPicture} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.OwnerPicture && formik.errors.OwnerPicture ? <small className="p-error">{formik.errors.OwnerPicture}</small> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button icon="pi pi-arrow-down" rounded aria-label="Download Owner Picture" onClick={() => downloadFile(ownerPictureFile, formik?.values?.OwnerPicture)} disabled={!ownerPictureFile} tooltip="Download File" />
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center mt-4 gap-2">
                    <Button label="Cancel" icon="pi pi-file-o" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => navigate('/draft-merchant-list')} />
                </div>
            </div>
        </form>
    );
};

export default ViewDraftMerchant;
